// extracted by mini-css-extract-plugin
export default {"boxedRadio":"styles_boxedRadio__fgrpj"};